module.exports = __webpack_public_path__ + "42ab61fa478611e961f3bfb9b60ae3b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/covers/fundraiser.png
// module id = 640
// module chunks = 4